import '../../styles/split-pane.css';

import type { CSSProperties, ReactNode } from 'react';
import Split from 'react-split';

export const SplitPane = ({
    children,
    secondaryInitialSize,
    minSize = 250,
    style,
}: {
    children: ReactNode;
    secondaryInitialSize: number;
    minSize?: number;
    style?: CSSProperties;
}) => {
    return (
        <Split
            className={'split-pane'}
            direction={'horizontal'}
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                gap: 8,
                ...style,
            }}
            gutterSize={3}
            snapOffset={0}
            expandToMin={true}
            minSize={minSize}
            sizes={[100 - secondaryInitialSize, secondaryInitialSize]}
        >
            {children}
        </Split>
    );
};
